import React, { useEffect } from "react";
import CloseButton from "../CloseButton/CloseButton";
import ProgressBar from "../progressBar/progressBar";
import ErrorBoundary from "../errorBoundary/errorBoundary";
import ProductTour from "./productTour";
import { COLORS } from "../../constants/colors";

const ProductTourContainer = ({
  stories,
  showProductTour,
  closeProductTour,
  isLoggedIn,
  completedStories,
}) => {
  const disableQuickStart = () => {
    localStorage.setItem("disableQuickStart", 1);
    closeProductTour();
  };

  useEffect(() => {
    closeProductTour();
  }, [isLoggedIn]);

  const getProgress = () => {
    const totalStories = stories?.length || 0;

    // Get the current state of stories from localStorage if available
    const storedStories = localStorage.getItem("gettingStartedStoriesState");
    const currentStories = storedStories ? JSON.parse(storedStories) : stories;

    // Count stories with completedCondition === "FINISHED"
    const finishedCount =
      currentStories?.filter((story) => story.completedCondition === "FINISHED")
        .length || 0;

    // Calculate progress based only on finished stories, not influenced by onlyForAnonymous
    const progress =
      totalStories > 0 ? (finishedCount / totalStories) * 100 : 0;

    return Math.round(progress);
  };

  const productTourContainerStyles = {
    width: showProductTour ? "25%" : "0",
    right: showProductTour ? "0px" : "-40px",
  };

  const disableProductTourStyles = {
    color: COLORS.YELLOW,
  };

  return (
    <div
      style={productTourContainerStyles}
      className="product_tour_sidebar_container"
    >
      <div className="product_tour_sidebar_inner">
        <div className="product_tour_sidebar_header">
          <h2>Quick Start</h2>
          <CloseButton
            className={"product_tour_closeButton"}
            onClick={closeProductTour}
          />
        </div>
        <ProgressBar bgColor={COLORS.LIGHT_BLUE} completed={getProgress()} />
      </div>
      <ErrorBoundary>
        <ProductTour
          isOpen={showProductTour}
          stories={stories}
          completedStories={completedStories}
          isLoggedIn={isLoggedIn}
        />

        <p
          onClick={disableQuickStart}
          className="quick-start-title"
          style={disableProductTourStyles}
        >
          Cancel Quick Start
        </p>
      </ErrorBoundary>
    </div>
  );
};

export default ProductTourContainer;
